import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { addAutomaticAppsApi, deleteAutomaticAppsApi, getAutomaticAppsApi, updateAutomaticAppsApi } from "../../../services/partners/settings/automaticAppsService";


export const getAllPartnerAutomaticApps = createAsyncThunk("partner/getAllPartnerAutomaticApps", async (filters, { dispatch }) => {
  const response = await getAutomaticAppsApi(filters);
  return response.response;
});

export const addPartnerAutomaticApps = createAsyncThunk("partner/addPartnerAutomaticApps", async (duration, { dispatch, getState }) => {
  try {
    const response = await addAutomaticAppsApi(duration);
    const data = await response.response;
    toast.success("Add Partner Automatic Apps successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const updatePartnerAutomaticApps = createAsyncThunk("partner/updatePartnerAutomaticApps", async (duration, { dispatch, getStatus }) => {
  try {
    const response = await updateAutomaticAppsApi(duration, duration.id);
    const data = await response.response;
    toast.success("Update Partner Automatic Apps successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const deletePartnerAutomaticApps = createAsyncThunk("partner/deletePartnerAutomaticApps", async (id, { dispatch, getStatus }) => {
  try {
    const response = await deleteAutomaticAppsApi(id);
    const data = await response.response;
    toast.success("Deleted Partner Automatic Apps successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

const partnerAutomaticAppsAdapter = createEntityAdapter({});

export const { selectAll: selectPartnerAutomaticApps, selectById: selectPartnerAutomaticAppsId } = partnerAutomaticAppsAdapter.getSelectors(
  (state) => state.partner.partnerAutomaticApps
);

const partnerAutomaticAppsSlice = createSlice({
  name: "partnerAutomaticApps",
  initialState: partnerAutomaticAppsAdapter.getInitialState({
    searchText: "",
    addDialog: {
      component: "PartnerAutomaticApps",
      type: "new",
      props: {
        open: false,
      },
      data: null,
    },
  }),
  reducers: {
    setPartnerAutomaticAppsSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
    openNewDialog: (state, action) => {
      state.addDialog = {
        component: "PartnerAutomaticApps",
        type: "new",
        props: {
          isOpen: true,
        },
        data: null,
      };
    },
    openEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: true,
        },
        data: action.payload,
      };
    },
    closeEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: false,
        },
        data: null,
      };
    },
  },
  extraReducers: {
    [getAllPartnerAutomaticApps.fulfilled]: partnerAutomaticAppsAdapter.setAll,
  },
});

export const { setPartnerAutomaticAppsSearchText, openNewDialog, closeNewDialog, openEditDialog, closeEditDialog } = partnerAutomaticAppsSlice.actions;

export default partnerAutomaticAppsSlice.reducer;
